<script lang="ts">
    import { Col,Badge } from "sveltestrap";
    import Card from "../UiCommenCard.svelte";
    import {Pillswithnumber} from "../../../utils/Constant/Constant";
    import data from "../../../Data/ComponentData/Ui-kits/TagsPills/TagsPills.json"
</script>
<Col sm="12" md="6">
  <Card cardHeaderprops="pb-0" headerTitle={Pillswithnumber}>
    <div slot="contentbody">
      <Badge pill color="primary">1</Badge>
      {#each data.PillswithIcondata as badgeItem}
        <Badge pill color={badgeItem.color}>{badgeItem.number}</Badge>
      {/each}
    </div>
  </Card>
</Col>